import React, { useRef, useState} from 'react'
import { Navigate } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import logoImage from '../../Assest/logo.png';
import '../Signin/Login.css'
import { Toast } from 'primereact/toast';

import { Api } from '../../services/api';


const ForgetPassword = () => {

    // const API_BASE_URL = 'http://161.97.86.43/demo/lidahome/api/';
    const toast = useRef(null);
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        email: '',
     
      });
    
      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
      };
    
      const handleSubmit = async (e) => {
        
        e.preventDefault();
    

        var url = Api.API_BASE_URL + 'send-email-forget-password';
    
        const token = localStorage.getItem('authToken'); // Retrieve token
    
        const headers = {
          'Authorization': token ? `Bearer ${token}` : '', // Include token if available
          'Content-Type': 'application/json', // Specify JSON content
        };

        fetch(url, {
            method: "POST",
            headers:headers,
          
            body: JSON.stringify(formData),
        })
            .then((response) => response.json())
            .then((Josn) => {
                
            
                
                if (Josn.error !== '') {
                    console.log(Josn.error);
                    toast.current.show({ severity: 'error', detail: Josn.error });
                   

                } else {
             
                    toast.current.show({ severity: 'success', detail: Josn.result }); 
                    setTimeout(function() {
                        window.location = "/";
                      }, 500);
                }
              
            })
            .catch((error) => {
                console.error("Error:", error);
            });
      };
    

  return (
    <>
    <Toast ref={toast} />
    <div className="container">
     
      <div className="section1"></div>
      <div className="section2"></div>
      <div className="main">
        <div className='mat-card'>
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
              {/* <img src={logoImage} alt="logo" className='img-class' /> */}
              <strong className='text-4xl'>Builder Playbook</strong>
            </div>
          <form onSubmit={handleSubmit} >
                          

            <div >
            <input className='input-log' type="email" placeholder="Email" name="email" value={formData.email} onChange={handleInputChange} required/>   
            </div> 

            <button  className='button-login' type="submit" >
              Submit
            </button>
          </form>

        </div>
      </div>
    </div></>
  );
};  



export default ForgetPassword







